"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _base = _interopRequireDefault(require("@emotion/styled/base"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _Dot = require("./Dot.styles");

var _useColor = _interopRequireDefault(require("../../hooks/useColor"));

var Container = (0, _base["default"])("span", {
  target: "e1siib2q0",
  label: "Container"
})(_Dot.styles.base, ";");

var Dot = function Dot(_ref) {
  var className = _ref.className,
      color = _ref.color,
      size = _ref.size;
  var bgColor = (0, _useColor["default"])(color);
  return (0, _jsxRuntime.jsx)(Container, {
    className: className,
    color: bgColor,
    size: size
  });
};

Dot.propTypes = {
  className: _propTypes.string,

  /**
   * Can be color or color string from theme (color.primary.brand)
   */
  color: _propTypes.string,
  size: (0, _propTypes.oneOf)(['big', 'small'])
};
Dot.defaultProps = {
  className: undefined,
  color: undefined,
  size: 'big'
};
var _default = Dot;
exports["default"] = _default;
//# sourceMappingURL=Dot.js.map